<template>
  <div>
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado v-if="encabezado" :elementos="encabezado" :action="action" />
      <v-card class="border-card-gray">
        <v-card-text>
          <div
            name="table"
            v-if="table"
            :class="[list.length < 6 ? 'calendar' : '']"
          >
            <v-row>
              <v-col cols="3" md="3" sm="3" class="pt-3" v-if="filterModality">
                <branch-offices-list
                :model="idBranchOfficeSelected"
                  v-on:triggerChange="branchOfficeSelected"
                />
              </v-col>
              <v-col cols="3" md="3" sm="3" v-if="filterDate">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="true"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Seleccione fecha"
                      clearable
                      :clear-icon="$cnst.CLEAR_ICON"
                      @click:append="clearCalendar()"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="month"
                    no-title
                    scrollable
                    locale="mx"
                    color="primary"
                    @input="updateDate"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  outlinedx
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <component
              key="table"
              :listAllPagination="listAllPagination"
              :idBranchOffice="idBranchOfficeSelected"
              :list="list"
              :is="table"
              :search="search"
              :currentPage="currentPage"
              :totalCount="totalCount"
            />
            <v-row dense>
              <v-col cols="8" md="8" sm="8" offset="2" class="text-center">
                <paginatesx
                  :click-handler="changePage"
                  :page-count="pageCount"
                  :page-range="1"
                  :margin-pages="1"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginatesx>
              </v-col>
              <v-col cols="2" md="2" sm="2" class="text-center mt-5">
                <v-banner outlined single-line>
                  Total: {{ totalCount }}</v-banner
                >
              </v-col>
            </v-row>
          </div>
          <div align="center">
            <v-menu
              offset-x
              bottom
              right
              :close-on-content-click="true"
              rounded="lg"
            >
              <template v-slot:activator="{ on: menu, attrs }">
                <v-btn
                  type="button"
                  class="mb-4"
                  :disabled="invalid"
                  v-bind="attrs"
                  depressed
                  outlined
                  v-on="{ ...menu }"
                  color="primary"
                  @click="downloadMonthlyReportXLSX()"
                >
                  {{ downloadButtonText }}
                  <v-icon right>mdi-download-multiple</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import BranchOfficesList from "@/components/BranchOfficesList.vue";

export default {
  name: "CrudView",
  components: {
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
  },
  data() {
    return {
      idBranchOffice: null,
      sending: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      encabezado: null,
      table: null,
      service: null,
      form: null,
      search: "",
      totalCount: 0,
      currentPage: 1,
      itemsPerPage: 10,
      searchDelay: null,
      pageCount: 1,
      idBranchOfficeSelected: null,
      filterModality: false,
      filterDate: false,
      date: null,
      menu: false,
      invalid: true,
      downloadButtonText: "",
    };
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
    },

    idBranchOfficeState() {
      this.listAllPagination();
    },
    date() {
      if (this.date !== null) {
        this.invalid = false;
      } else {
        this.invalid = true;
        this.listAllPagination();
      }
    },
  },

  async mounted() {
    this.service = (await this.$route.meta.service()).default;
    this.table = (await this.$route.meta.table()).default;
    this.encabezado = this.$route.meta.header;
    this.filterModality = this.$route.meta.filterModality || false;
    this.filterDate = this.$route.meta.filterDate || false;
    this.downloadButtonText =
      this.$route.meta.downloadButtonText || "Descargar";
    this.listAllPagination();
  },
  computed: {
    ...mapState(["idBranchOfficeState"]),
  },
  methods: {
    // ...mapActions(["updateBranchOffice", "updateAction"]),
    clearCalendar() {
      this.date = null;
      this.listAllPagination();
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
    },
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
      this.sending = true;
      let params = {
        search: this.search,
        maxResults: this.itemsPerPage,
        page: this.currentPage,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      if (this.$utilFront.nonEmpty(this.date)) {
        params.start = this.$utilFront.startOfMonth(this.date);
        params.end = this.$utilFront.endOfMonth(this.date);
      }
      this.service
        .listAllPagination(params)
        .then((res) => {
          this.sending = false;
          let { list, count } = res.data;
          this.list = list;
          this.totalCount = count;
          this.pageCount = Math.ceil(count / this.itemsPerPage);
        })
        .catch((e) => {
          this.sending = false;
          this.$utilFront.errorhttp(e);
        });
    },
    updateDate() {
      this.$refs.menu.save(this.date);
      this.listAllPagination();
    },
    downloadMonthlyReportXLSX() {
      if (!this.sending) {
        this.sending = true;
        let params = {
          search: this.search,
          start: this.$utilFront.startOfMonth(this.date),
          end: this.$utilFront.endOfMonth(this.date),
          idBranchOffice:
            this.idBranchOfficeSelected != null
              ? this.idBranchOfficeSelected
              : this.$utilFront.getIdBranchOffice(),
        };
        let dateName = `${moment(this.date).locale("es").format('MMMM')}_${moment(this.date).format('YYYY')}`;   
        let fileName = `Historico_estudios_${dateName}.xlsx`;
        this.service
          .downloadReport(params)
          .then((res) => {
            let { data } = res;
            this.$utilFront.downloadXLSX(data, fileName);
          })
          .catch((error) => {
            this.$utilFront.errorhttp(error);
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
  },
};
</script>
